import { Injectable } from '@angular/core';
import { IIDolSospensioneStore } from './iidOlSospensione.store';
import { IID_OL_SOSPENSIONE } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDolSospensioneQuery } from './iidOlSospensione.query'
import { CrudService } from '../crudService';
import { IssueEntityStoreStrategy } from '../updateStoreStrategies';
@Injectable({
  providedIn: 'root'
})
export class IIDolSospensioneService extends CrudService<IID_OL_SOSPENSIONE, IIDolSospensioneStore, IIDolSospensioneQuery> {
  constructor(
    protected store: IIDolSospensioneStore,
    protected query: IIDolSospensioneQuery,
    protected actionService: ActionService,
    protected updateStrategy: IssueEntityStoreStrategy) {
    super(
      Topics.IID_OL_SOSPENSIONE,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
